const shareNetwork = {
	"index-view": {
		title: "Invite Your Network",
		tutorial: {
			title: "How the Referral Program Works",
		},
		heading: {
			title: "Refer Companies and Earn up to €50 per Company",
			description:
				"When a company signs up, you get €25. Does the company then post a project over €150? We will add €25 more.",
		},
	},
};
export default shareNetwork;
